<template>
  <div class="container">
    <Progress :active-index="stepNum" />
    <div class="main">
      <!-- <a-spin :spinning="spinning" /> -->
      <Step3
        v-if="step === 2"
        :insureNotice="insureNotice"
        :stepNum.sync="stepNum"
      />
      <Step2 v-if="step === 1" />

      <Step1
        ref="step1"
        v-if="step === 0"
        :step="step"
        :data-source="dataSource"
        :spinning="spinning"
        @confirm="confirm"
      />
      <Operate class="operate" :step="step" :is-next="isNext" />
    </div>
    <div class="notice-dialog">
      <a-modal
        v-if="step == 0"
        v-model="insureInfoDialog.visible"
        title="保函开立须知"
        centered
        :mask-closable="false"
        :closable="false"
      >
        <div class="content" v-html="insureNotice" />

        <div>
          <a-form :form="form">
            <a-form-item v-if="readDocMap.length">
              <a-checkbox
                v-decorator="[
                  'checked',
                  { rules: [{ validator: compareToFirstChecked }] }
                ]"
                style="width: 100%;padding-top:10px"
              >
                已阅读并同意
                <a
                  v-for="(item, index) in readDocMap"
                  :key="index"
                  class="hrefa"
                  :href="`/api/contract/downloadView?source=${item.path}`"
                  target="_bank"
                  >《{{ item.name }}》</a
                >
              </a-checkbox>
            </a-form-item>
          </a-form>
        </div>

        <template v-slot:footer>
          <a href="javascript;">
            <a-button>
              不同意，取消开立
            </a-button>
          </a>
          <a-button
            :disabled="timer == 0 ? false : true"
            @click="onArree"
            type="primary"
          >
            我已阅读开立须知并同意 {{ timer == 0 ? "" : `${timer}s` }}
          </a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import invitationLetterTpl from "@/assets/tpl/invitationLetter.js";
import Progress from "./../../components/Progress";
import Operate from "./components/Operate";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";
import {
  information,
  getInformation,
  verify,
  getChannelInfo,
  getList
} from "@/api/insure.js";
export default {
  name: "InsurePage",
  components: {
    Progress,
    Operate,
    Step1,
    Step2,
    Step3
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: "dynamic_rule" }),
      readDocMap: [],
      stepNum: 0,
      spinning: false,
      orderNo: "",
      status: "",
      step: 0,
      dataSource: {},
      invitationLetterTpl,
      stepList: ["填写投保信息", "合同签署", "提交投保完成"],
      pickCompanyCode: "",
      insureInfoDialog: {
        visible: false
      },
      isNext: false,
      upLoadList: {},
      insureNotice: "",
      certTypeList: [],
      envUrl: process.env.VUE_APP_DANBAO_HREF,
      timer: 5,
      dataJson: {}
    };
  },
  created() {
    this.getInformation();
    this.nextStatus();
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.step1.init();
    });
  },
  methods: {
    OnClose() {
      this.timer = 0;
      this.insureInfoDialog.visible = false;
    },
    onArree() {
      this.form.validateFields(err => {
        if (!err) {
          information(this.dataJson).then(res => {
            if (res.data.status === 200) {
              this.nextStatus();
              this.step = 1;
              this.insureInfoDialog.visible = false;
            } else {
              console.log();
              this.insureInfoDialog.visible = false;
              this.$notification.error({
                message: res.data.message
              });
            }
            this.spinning = false;
          }).catch((err)=>{
            
          })
        }
      });
    },
    compareToFirstChecked(rule, value, callback) {
      if (!value) {
        callback("请勾选协议");
      } else {
        callback();
      }
    },
    // 倒计时
    countDownTimer() {
      if (this.timer > 0) {
        setTimeout(() => {
          this.timer -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getInformation() {
      this.spinning = true;
      this.orderNo = this.getQueryString("orderNo");
      getInformation({ orderNo: this.orderNo }).then(response => {
        const res = response.data;
        this.status = res.status;
        this.dataSource = res;
        this.spinning = false;
        // 显示第几步
        if (res.status === "1") {
          this.step = 0;
        } else if (res.status === "2") {
          this.step = 1;
        } else {
          this.step = 2;
        }
      });
    },
    // 下一步
    information() {
      this.orderNo = this.getQueryString("orderNo");
      if (this.step === 0) {
        this.$refs.step1.form.validateFields((err, values) => {
          if (!err) {
            this.spinning = true;
            this.dataJson = {
              orderNo: this.orderNo,
              invoiceType: values.invoiceType,
              invoiceHead: values.invoiceHead,
              invoiceCuscCode: values.invoiceCuscCode,
              invoiceEmail: values.invoiceEmail,
              period: values.period,
              mobile: values.mobile,
              code: values.code,
              phCode: values.phCode,
              partnerCode: values.partnerCode,
              addInfo: values.addInfo,
              bankInfo: values.bankInfo,
              bankAcc: values.bankAcc,
              addressee: values.addressee,
              addresseePhone: values.addresseePhone,
              address: values.address
            };
            this.timer = 5;
            this.countDownTimer();
            this.insureInfoDialog.visible = true;
          }
        });
      } else if (this.step === 1) {
        verify({ orderNo: this.orderNo }).then(({ data: data }) => {
          if (data.status == 200) {
            this.nextStatus();
            this.step = 2;
          }
        });
      }
    },
    confirm(form1) {
      this.$refs.step1.form.validateFields((err, values) => {
        if (!err) {
          console.log(values, this.$refs.step1, form1, "form1");
          // if (!values.checked) {
          //   this.$message.warning('请勾选协议');
          //   return false;
          // }
          this.spinning = true;
          if (form1.partnerCode === "xiaMenBank") {
            this.upLoadList = {
              businessLicenseImage:
                !this.$refs.step1.file1 && values.businessLicenseImage
                  ? values.businessLicenseImage.file.response.data.uri
                  : this.$refs.step1.businessLicenseImage[0].url,
              legalPersonCardImage:
                !this.$refs.step1.file2 && values.legalPersonCardImage
                  ? values.legalPersonCardImage.file.response.data.uri
                  : this.$refs.step1.legalPersonCardImage[0].url,
              biddingDocumentUrl:
                !this.$refs.step1.file3 && values.biddingDocumentUrl
                  ? values.biddingDocumentUrl.file.response.data.uri
                  : this.$refs.step1.biddingDocumentUrl[0]
                  ? this.$refs.step1.biddingDocumentUrl[0].url
                  : ""
              // bidCommitmentUrl: !this.$refs.step1.file4 && values.bidCommitmentUrl ? values.bidCommitmentUrl.file.response.data.uri : this.$refs.step1.bidCommitmentUrl[0].url,
              // separateGuaranteePromiseUrl: !this.$refs.step1.file5 && values.separateGuaranteePromiseUrl ? values.separateGuaranteePromiseUrl.file.response.data.uri : this.$refs.step1.separateGuaranteePromiseUrl[0].url,
            };
          }
          const data = {
            orderNo: this.orderNo,
            responsiblePersonPhone: values.phoneNum,
            partnerCode: form1.partnerCode,
            ...this.upLoadList
          };
          verify(data)
            .then(res => {
              console.log(res);
              if (res.status === 200) {
                this.step = 2;
              } else {
                this.$notification.error({
                  message: res.message
                });
              }
              this.spinning = false;
            })
            .catch(err => {
              this.$refs.step1.hiddenModal();
              this.spinning = false;
              const errorMsg = err.response.data.message;
              this.$notification.error({
                message: errorMsg
              });
            });
        }
      });
    },
    back() {
      this.step -= 1;
      if (this.step === 0) {
        this.orderNo = this.getQueryString("orderNo");
        getInformation({ orderNo: this.orderNo }).then(response => {
          this.dataSource = response.data;
          this.$nextTick(() => {
            this.$refs.step1.initInfo();
          });
        });
      }
    },
    closePage() {
      if (
        navigator.userAgent.indexOf("Firefox") !== -1 ||
        navigator.userAgent.indexOf("Chrome") !== -1
      ) {
        window.location.href = "about:blank";
        window.close();
      } else {
        window.opener = null;
        window.open(" ", "_self");
        window.close();
      }
    },
    async nextStatus() {
      this.orderNo = this.getQueryString("orderNo");
      const { data: data } = await getInformation({ orderNo: this.orderNo });
      this.stepNum = data.status;
    },
    getList(list) {
      this.insureNotice = list.redTxt;
      if (list.files) {
        this.readDocMap = JSON.parse(list.files);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fff;
  min-height: 726px;
  margin-top: 30px;
  position: relative;
}

.main {
  padding: 30px 50px 95px;
}

.pickCompany {
  margin-top: 90px;
}

.operate {
  margin-top: 80px;
}

// .notice-dialog {
::v-deep .ant-modal {
  width: 960px !important;
}

::v-deep .ant-modal-content {
  width: 960px !important;
  min-height: 680px !important;
  padding: 45px 50px;
  box-sizing: border-box;
}

::v-deep .ant-modal-body {
  padding: 24px 0 !important;
}

::v-deep .ant-modal-header {
  border-bottom: none;
}

::v-deep .ant-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: center;
}

::v-deep .ant-modal-footer {
  border-top: none;
  display: flex;
  justify-content: center;
}

::v-deep .ant-modal-footer button {
  padding: 12px 26px;
  height: auto;
  font-size: 16px;
  line-height: 1;
  margin-left: 50px;
}

// }
.content {
  height: 392px;
  padding: 30px;
  box-sizing: border-box;
  overflow-y: scroll;
  border: 1px solid #e5e5e5;
}
</style>
